import { XIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

const SwitchLayoutBanner = ({
  labelKey,
  onSwitch,
  onDismiss,
  variant = "light",
  direction = "forward",
}) => {
  const { t } = useTranslation();

  const isLight = variant === "light";
  const bgClass = isLight ? "bg-white" : "bg-blue-600";
  const textClass = isLight ? "text-gray-500" : "text-white";
  const arrow = direction === "back" ? "\u2190" : "\u2192";

  return (
    <div
      className={`flex items-center gap-x-6 ${bgClass} px-6 py-2.5 sm:px-3.5 sm:before:flex-1 rounded-lg`}
    >
      <button type="button" onClick={onSwitch}>
        <p className={`text-sm leading-6 ${textClass}`}>
          {direction === "back" && (
            <>
              <span aria-hidden="true">{arrow}</span> &nbsp;
            </>
          )}
          {t(labelKey)}
          {direction === "forward" && (
            <>
              &nbsp;<span aria-hidden="true">{arrow}</span>
            </>
          )}
        </p>
      </button>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          onClick={onDismiss}
          className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
        >
          <span className="sr-only">Dismiss</span>
          <XIcon aria-hidden="true" className={`h-5 w-5 ${textClass}`} />
        </button>
      </div>
    </div>
  );
};

export default SwitchLayoutBanner;
